import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Notification } from '../models/notification.interface';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private notificationSubject = new Subject<Notification>();
  public notifications$ = this.notificationSubject.asObservable();

  /**
   * Show a notification
   * @param text - The notification message
   * @param type - The notification type ('success', 'error', or 'info')
   */
  show(text: string, type: 'success' | 'error' | 'info' = 'info'): void {
    let sanitizedText = text;
    if (typeof sanitizedText === 'string' && /existing\s+and\s+valid/i.test(sanitizedText)) {
      sanitizedText = 'GSTIN details verified successfully.';
      type = 'success';
    }
    const notification: Notification = {
      id: this.generateId(),
      text: sanitizedText,
      type,
    };
    this.notificationSubject.next(notification);
  }

  /**
   * Convenience method for success notifications
   */
  success(text: string): void {
    this.show(text, 'success');
  }

  /**
   * Convenience method for error notifications
   */
  error(text: string): void {
    this.show(text, 'error');
  }

  /**
   * Convenience method for info notifications
   */
  info(text: string): void {
    this.show(text, 'info');
  }

  /**
   * Generate a unique ID for each notification
   */
  private generateId(): string {
    return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  }
}
